import { isGlobalworth, paths } from 'config'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'
import { History as HistorySVG, DrawerHistory } from 'shared/assets'

const routes: ModuleRoute[] = [
  {
    path: paths.history,
    admin: false,
    exact: true,
    linkSettings: {
      icon: isGlobalworth ? HistorySVG : DrawerHistory,
      label: 'nav.history',
    },
    component: Loadable({
      component: () => import('./pages'),
    }),
    layoutSettings: {},
  },
]

export default routes
